import React from 'react';
import { WizardState } from '../../../hooks/useZakatWizard';
import { Input } from '../../ui/Input';
import { Card } from '../../ui/Card';
import { Info } from 'lucide-react';
interface BusinessAssetsStepProps {
  state: WizardState;
  updateState: (updates: Partial<WizardState>) => void;
}
export function BusinessAssetsStep({
  state,
  updateState
}: BusinessAssetsStepProps) {
  return <div className="space-y-6" data-id="element-269">
      <div className="mb-6" data-id="element-270">
        <h2 className="text-2xl font-bold text-gray-900 font-serif mb-2" data-id="element-271">
          Business Assets
        </h2>
        <p className="text-gray-600" data-id="element-272">
          For business owners: include inventory at cost, accounts receivable,
          and cash in business accounts. Don't include fixed assets like
          equipment or property.
        </p>
      </div>

      <div className="bg-blue-50 border border-blue-100 rounded-lg p-4 flex gap-3 text-sm text-blue-800 mb-6" data-id="element-273">
        <Info className="h-5 w-5 flex-shrink-0 mt-0.5" data-id="element-274" />
        <p data-id="element-275">
          Fixed assets (machinery, buildings, furniture) used for the business
          are NOT zakatable. Only current assets (cash, inventory, receivables)
          are subject to Zakat.
        </p>
      </div>

      <Card className="space-y-6" data-id="element-276">
        <Input label="Inventory (At Cost)" prefix="$" type="number" min="0" placeholder="0.00" value={state.businessInventory || ''} onChange={e => updateState({
        businessInventory: parseFloat(e.target.value) || 0
      })} data-id="element-277" />

        <Input label="Business Cash Accounts" prefix="$" type="number" min="0" placeholder="0.00" value={state.businessCash || ''} onChange={e => updateState({
        businessCash: parseFloat(e.target.value) || 0
      })} data-id="element-278" />

        <Input label="Accounts Receivable" prefix="$" type="number" min="0" placeholder="0.00" value={state.businessReceivables || ''} onChange={e => updateState({
        businessReceivables: parseFloat(e.target.value) || 0
      })} data-id="element-279" />
      </Card>
    </div>;
}